<template>
	<div class="con">
		<div class="nav">
			<div class="nav-list" v-for="(item,index) in nav" @click="navBtn(item.id)">
				<div class="text" :class="[item.id == navIndex ? 'navActive':'']">{{item.text}}</div>
			</div>
		</div>
		<div class="time">
			<van-icon name="arrow-left" size="25px" :disabled="isDis" @click="onTime" />
			<div>{{choosTime}}</div>
			<van-icon name="arrow" size="25px" :disabled="isDis" @click="nextTime" />
		</div>
		<div class="list">
			<div v-if="List != 0" id="chart_pie" ref="chart_pie"></div>
		</div>
		<div class="list">
			<div v-if="List != 0" id="chart_bar" ref="chart_bar"></div>
		</div>
		<div class="noImg" v-if="List.length == ''">
			<img src="../assets/404.gif" />
			<div class="no-text">无数据~</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'staIncome',
		data() {
			return {
				nav: [{
						id: 0,
						text: '年'
					},
					{
						id: 1,
						text: '月'
					},
				],
				navIndex: 0,
				choosTime: '', //显示的时间
				saveTimeYear: '',
				saveTimeMonth: '',
				saveTimeDay: '',
				isDis: true, //防止猛击按钮
				List: [],
			}
		},
		methods: {
			//科室报表
			GetOfficeReport() {
				this.$store.commit('Load', true)
				let time = this.choosTime;
				time = time.split("-");
				
				if(time[1] == undefined){
					time[1] = '';
				}
				let that = this;
				this.$Axios.Get('/getOfficeReport?year=' + time[0] + '&month=' + time[1], null).then(res => {
					console.log(res)
					this.$store.commit('Load', false)
					if(res.code == 0) {
						this.List = res.msg.INPAT;
						if(res.msg.INPAT != 0) {
							setTimeout(() => {
								that.totalBar();
								that.totalPie();
							}, 300)
						}

					}else{
						console.log(1)
						
					}
				}).catch(err => {
					this.$store.commit('Load', false)
					this.List = '';
					console.log(err)
				})
			},
			navBtn(e) {
				console.log(e)
				this.newText = this.nav[e].text;
				this.navIndex = e;
				let newT;
				switch(this.navIndex) {
					case 0:
						newT = this.$timeformat.timestampToTime(this.saveTimeYear);
						newT = newT.split(" ")[0];
						newT = newT.split("-");
						this.choosTime = newT[0];
						break;
					case 1:
						newT = this.$timeformat.timestampToTime(this.saveTimeMonth);
						newT = newT.split(" ")[0];
						newT = newT.split("-");
						this.choosTime = newT[0] + "-" + newT[1];
						break;
					case 2:
						newT = this.$timeformat.timestampToTime(this.saveTimeDay);
						newT = newT.split(" ")[0];
						newT = newT.split("-");
						this.choosTime = newT[0] + "-" + newT[1] + "-" + newT[2];
						break;
				}
				this.GetOfficeReport()
			},
			newTime() {
				let newT = this.$timeformat.timestampToTime(new Date());
				let newTime = newT.split(" ")[0];
				let timeSplit = newTime.split("-");
				this.choosTime = timeSplit[0];
				this.saveTimeYear = new Date().getTime();
				this.saveTimeMonth = new Date().getTime();
				this.saveTimeDay = new Date().getTime();
			},
			//上一个
			onTime() {
				let that = this;
				if(this.isDis == true) {
					switch(this.navIndex) {
						case 0:
							let countTimeYear = this.saveTimeYear - 1000 * 60 * 60 * 24 * 30 * 12;
							this.saveTimeYear = countTimeYear;
							let cTimeYear = this.$timeformat.timestampToTime(countTimeYear);
							cTimeYear = cTimeYear.split(" ")[0];
							cTimeYear = cTimeYear.split("-");
							this.choosTime = cTimeYear[0];
							break;
						case 1:
							let countTimeMoth = this.saveTimeMonth - 1000 * 60 * 60 * 24 * 30;
							this.saveTimeMonth = countTimeMoth;
							let cTimeMoth = this.$timeformat.timestampToTime(countTimeMoth);
							cTimeMoth = cTimeMoth.split(" ")[0];
							cTimeMoth = cTimeMoth.split("-");
							this.choosTime = cTimeMoth[0] + "-" + cTimeMoth[1]
							break;
						case 2:
							let countTimeDay = this.saveTimeDay - 1000 * 60 * 60 * 24;
							this.saveTimeDay = countTimeDay;
							let cTimeDay = this.$timeformat.timestampToTime(countTimeDay);
							cTimeDay = cTimeDay.split(" ")[0];
							this.choosTime = cTimeDay
							break;
					}
					this.isDis = false;
					setTimeout(() => {
						that.isDis = true;
					}, 500)
				}
				this.GetOfficeReport()

			},
			//下一个
			nextTime() {
				let that = this;
				if(this.isDis == true) {
					switch(this.navIndex) {
						case 0:
							let countTimeYear = this.saveTimeYear + 1000 * 60 * 60 * 24 * 30 * 12;
							this.saveTimeYear = countTimeYear;
							let cTimeYear = this.$timeformat.timestampToTime(countTimeYear);
							cTimeYear = cTimeYear.split(" ")[0];
							cTimeYear = cTimeYear.split("-");
							this.choosTime = cTimeYear[0];
							break;
						case 1:
							let countTimeMoth = this.saveTimeMonth + 1000 * 60 * 60 * 24 * 30;
							this.saveTimeMonth = countTimeMoth;
							let cTimeMoth = this.$timeformat.timestampToTime(countTimeMoth);
							cTimeMoth = cTimeMoth.split(" ")[0];
							cTimeMoth = cTimeMoth.split("-");
							this.choosTime = cTimeMoth[0] + "-" + cTimeMoth[1]
							break;
						case 2:
							let countTimeDay = this.saveTimeDay + 1000 * 60 * 60 * 24;
							this.saveTimeDay = countTimeDay;
							let cTimeDay = this.$timeformat.timestampToTime(countTimeDay);
							cTimeDay = cTimeDay.split(" ")[0];
							this.choosTime = cTimeDay
							break;
					}
					this.isDis = false;
					setTimeout(() => {
						that.isDis = true;
					}, 500)
				}
				this.GetOfficeReport()

			},
			//柱形图
			totalBar() {
				let myChartBar = this.$echarts.init(this.$refs.chart_bar);
				if(myChartBar) {
					let dataList = this.List;
					let dataN = [];//名称
					let dataL = [];//总金额
					let dataSl = [];//门诊就诊人数
					let dataYsSl = [];//值班医生数

					for(let i in dataList) {
						dataN.push(dataList[i].INPAT_KSMC);
						dataL.push(dataList[i].INPAT_FYHJ);
						dataSl.push(dataList[i].INPAT_YS_SL);
						dataYsSl.push(dataList[i].INPAT_YS_SL);
					}
					let option = {
						color: ['#3398DB'],
//						title: {
//							text: '科室就诊收入',
//							top: '10',
//							left: 'center',
//						},
						tooltip: {
							trigger: 'axis',
							axisPointer: { // 坐标轴指示器，坐标轴触发有效
								type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
							}
						},
						grid: {
							left: '3%',
							right: '4%',
							bottom: '3%',
							containLabel: true
						},
						xAxis: [{
							type: 'value',
//							show: false,
							axisTick: {
								alignWithLabel: true
							},

						}],
						yAxis: [{
							type: 'category',
							axisLine: {
								show: false
							},
							data: dataN,
							splitLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							nameTextStyle: {
								fontSize: 16,
							},
							axisLabel: {
								interval: 0,
								rotate: 40,
								textStyle: {
									color: '#000',
								}
							},
						}],
						legend: {
					        data: ['收入', '就诊人数', '值班医生']
					    },
						series: [
							{
								type: 'bar',
								name:'收入',
								data: dataL,
								label: {
									show: true,
									formatter: '{c}',
									color: '#000'
								},
								itemStyle: {
									normal: {
										barBorderRadius: [0, 10, 10, 0],
										color: '#27BEC4'
									}
								}
							},
							{
								type: 'bar',
								name:'值班医生',
								data: dataYsSl,
								label: {
									show: true,
									formatter: '{c}',
									color: '#000'
								},
								itemStyle: {
									normal: {
										barBorderRadius: [0, 10, 10, 0],
										color: 'red'
									}
								}
							},
							{
								type: 'bar',
								name:'就诊人数',
								data: dataSl,
								label: {
									show: true,
									formatter: '{c}',
									color: '#000'
								},
								itemStyle: {
									normal: {
										barBorderRadius: [0, 10, 10, 0],
										color: '#2f4554'
									}
								}
							}
						]
					};
					myChartBar.setOption(option);
				}

			},
			//饼状图
			totalPie() {
				let myChartPie = this.$echarts.init(this.$refs.chart_pie);
				if(myChartPie) {
					let dataList = this.List;
					let dataN = [];
					let dataL;
					for(let i in dataList) {
						dataN.push(dataList[i].INPAT_KSMC);
					}

					dataL = JSON.parse(JSON.stringify(dataList).replace(/INPAT_SL/g, "value").replace(/INPAT_KSMC/g, "name"))
					let option = {
						title: {
							text: '科室就诊人数百分比',
							top: '5',
							left: 'center',
						},
						tooltip: {
							trigger: 'item',
							formatter: '{b}: {c} ({d}%)'
						},
						legend: {
							top: 'bottom',
							left: 'center',
							data: dataN,
						},
						series: [{
							type: 'pie',
							radius: ['30%', '50%'],
							center: ['50%', '45%'],
							minAngle: 10, // 设置每块扇形的最小占比
							hoverAnimation: false,
							avoidLabelOverlap: false,
							label: {
								show: false,
								position: 'center'
							},
							itemStyle: {
								normal: { //饼状图上的文本显示
									label: {
										show: true,
										position: 'outside',
										formatter: "{d}%", //数值和百分比
										textStyle: {
											fontSize: 12,
											fontWeight: 'bolder'
										}
									},

								}
							},

							labelLine: {
								show: true,
							},
							data: dataL,
						}]
					};

					myChartPie.setOption(option);
				}

			}
		},
		mounted() {
			this.newTime()
			this.GetOfficeReport();

		},
		created() {

		},
	}
</script>

<style scoped>
	.con {
		padding: 0 0 10px 0;
		width: 100%;
		background-color: #27BEC4;
	}
	
	.nav {
		padding: 10px;
		display: flex;
		justify-content: center;
		background: #27BEC4
	}
	
	.nav-list {
		border: 1px solid #fff;
		
	}
	
	.text {
		padding: 10px 55px;
		color: #fff;
		font-size: 16px;
		text-align: center;
	}
	
	.time {
		padding: 15px 0;
		display: flex;
		justify-content: space-around;
		align-content: center;
		font-size: 18px;
		color: #fff;
		background: #27BEC4;
	}
	
	.navActive {
		background: #fff;
		color: #000;
	}
	
	.list-head {
		display: flex;
		justify-content: space-around;
		align-items: center;
		padding: 10px 0;
		background: #27BEC4;
		width: 100%;
		color: #000;
	}
	.list {
		background-color: #fff;
		margin: 10px 15px;
		border-radius: 10px;
	}
	
	#chart_pie {
		width: 100%;
		height: 50vh;
		margin: 0 auto;
	}
	
	#chart_bar {
		width: 100%;
		height: 50vh;
		margin: 0 auto;
	}
	
	.noImg {
		margin-top: 10vh;
		text-align: center;
	}
	
	.no-text {
		margin-top: 10px;
		color: #fff;
		font-size: 16px;
	}
	
</style>